//  Check Posting component
/* eslint-disable no-unused-vars */
import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import FilePondSingleUpload from 'uploader/FilePondSingleUpload';
import Uploader from 'modules/common/components/Uploader';
import DateInputPicker from 'modules/common/components/DateInputPicker2';
import useFormValidator from 'useFormValidator';
import NumberFormat from 'react-number-format';
import moment from 'moment';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import ImagePlaceholder from 'assets/img/image-placeholder.jpg';

import * as actions from '../actions';
import * as c from '../constant';

function UpdateModal({
  manualPaymentPosting,
  // showTransaction,
  getItem,
  id,
  posting,
  transactionInfo,
}) {
  const setModal = useContext(ModalContext);
  const [formData, setFormData] = useState({
    check_reference_url: '',
    check_no: '',
    check_date: '',
    bank_name: '',
    amount: '',
  });

  const validateForm = useFormValidator(formData, {
    check_reference_url: 'required',
    check_no: 'required',
    check_date: 'required',
    bank_name: 'required',
    amount: 'required', // transaction amount should be >= 500000
  
  });

  const handleOnSubmit = e => {
    e.preventDefault();

    const args = {
      ...formData,
    };

    manualPaymentPosting(id, args, () => {
      setModal({ isOpen: false });
      // showTransaction(id);
      getItem(id);
    });
  };

  const closeModal = e => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  const onChange = e => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const onChangePhoto = key => data => {
    setFormData({
      ...formData,
      [key]: data,
    });
  };

  const handleOnChangeDate = key => e => {
    setFormData({
      ...formData,
      [key]: e.target.value,
    });
  };

  useEffect(() => {
    validateForm.validate();
  }, [Object.values(formData).join(',')]);

  const applicationDate =
    moment(_.get(transactionInfo, 'attributes.processing_at')).format(
      'MM/DD/YYYY'
    ) || '';

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row d-flex justify-content-center">
          <div className="col-md-12 ">
            <div className="col-12">
              <label className="form-control-plaintext form-label">
                Uploaded Check:{' '}
                {validateForm.renderMessage('check_reference_url')}
              </label>
            </div>
            <div className="col-12">
              <img
                className="w-100 rounded"
                src={
                  !_.isObject(
                    _.get(formData, 'check_reference_url') || ''
                  )
                    ? _.get(formData, 'check_reference_url') ||
                      ImagePlaceholder
                    : _.get(formData, 'check_reference_url.cdnUrl') ||
                      ImagePlaceholder
                }
                alt=""
              />
            </div>
            <div className="col-12 form-group">
              <FilePondSingleUpload onChange={onChangePhoto('check_reference_url')} />
              {/* <Uploader
                className="btn btn-block btn-primary cms-bg-color-primary cms-outline-primary     "
                customLoading={<i className="fas fa-spinner fa-spin" />}
                icon={<i className="far fa-image" />}
                label="Upload Photo"
                onChange={onChangePhoto('check_reference_url')}
                crop="free"
                imagesOnly
              /> */}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Check Number:{' '}
              {validateForm.renderMessage('check_no')}
            </label>
            <input
              className="form-control"
              type="text"
              name="check_no"
              onChange={onChange}
              value={_.get(formData, 'check_no')}
            />
          </div>
          <div className="col-12 form-group">
            <label>
              Check Date: {validateForm.renderMessage('check_date')}
            </label>
            <DateInputPicker
              className="form-control"
              minDate={new Date(applicationDate)}
              maxDate={new Date()}
              onChange={handleOnChangeDate('check_date')}
              value={_.get(formData, 'check_date') || ''}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Bank Name: {validateForm.renderMessage('bank_name')}
            </label>
            <input
              className="form-control"
              type="text"
              name="bank_name"
              onChange={onChange}
              value={_.get(formData, 'bank_name')}
            />
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="full-label mb-0">
              Amount: {validateForm.renderMessage('amount')}
            </label>
            {/* <input
              className="form-control"
              type="text"
              name="amount"
              onChange={onChange}
              value={_.get(formData, 'amount')}
            /> */}
            <NumberFormat
              name="capital_amount"
              id="capital_amount"
              placeholder="0.00"
              fixedDecimalScale={2}
              allowLeadingZeros
              className="form-control"
              onValueChange={(values) => {
                const { floatValue } = values;
                setFormData({
                  ...formData,
                  amount: floatValue,
                })
              }}
              displayType="input"
              isNumericString
              thousandSeparator
              prefix="₱ " 
              value={_.get(formData, 'amount')?.toString() || ""}
            />
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            disabled={posting || !validateForm.response.is_passed}
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary      mr-3"
          >
            <span className="font-weight-bold">
              {posting ? <i className="fa fa-spin fa-spinner" /> : `Submit`}
            </span>
          </button>
          <button
            disabled={posting}
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

UpdateModal.propTypes = {
  // showTransaction: PropTypes.instanceOf(Function).isRequired,
  manualPaymentPosting: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,

  // item: PropTypes.instanceOf(Object).isRequired,
  getItem: PropTypes.instanceOf(Function).isRequired,

  id: PropTypes.string.isRequired,
  posting: PropTypes.bool.isRequired,
};

const mapStateToProps = ({ api }) => ({
  posting: api.loading.indexOf(c.MANUAL_PAYMENT_POSTING) > -1,
});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(UpdateModal);
